import request from "@/utils/http"
import { getCachedObj, removeCache } from "@/utils/cache"
import { isValidObjectId } from "@/utils/common"
import { Message } from "element-ui"
import store from "@/store"

export function getApp({ appId, companyId, cache = true }) {
  let reqFunc = () => request.get("/public/getApp", { params: { appId, companyId } }).commonDeal()
  if (!cache) {
    return reqFunc()
  }
  let key = `getApp_${appId}`
  return getCachedObj({ key, reqFunc })
}

export function getAllSheetGroup({ appId, cache = true }) {
  let reqFunc = () => request.get("/public/getAllSheetGroup", { params: { appId } }).commonDeal()
  if (!cache) {
    return reqFunc()
  }
  let key = `getAllSheetGroup_${appId}`
  return getCachedObj({ key, reqFunc })
}

export function getSheet(sheetId) {
  return request.get("/public/getSheet", { params: { sheetId } }).commonDeal()
}

export function getAvailableSheet(appId) {
  return request.get("/public/getAvailableSheet", { params: { appId } }).commonDeal()
}

export function getSimpleView(appId, viewId) {
  return request.get(`/public/getSimpleView`, { params: { appId, viewId } }).commonDeal()
}

export function getSheetDefForDetail(sheetId, dataId) {
  return request.get(`/public/getSheetDefForDetail`, { params: { sheetId, dataId } }).commonDeal()
}

export function getSheetDefForEdit(sheetId, dataId) {
  return request.get(`/public/getSheetDefForEdit`, { params: { sheetId, dataId } }).commonDeal()
}

export function getSheetDataForDetail({ dataId, appId }) {
  if (!isValidObjectId(dataId)) {
    Message.error("数据不存在")
    return Promise.reject("数据不存在")
  }
  return request.get(`/public/getSheetDataForDetail`, { params: { dataId, appId } }).commonDeal()
}

export function getSheetDataById(sheetId, dataId) {
  return request.get("/public/getSheetDataById", { params: { sheetId, dataId } }).commonDeal()
}

export function getSheetData({
  sheetId,
  viewId,
  dataIds = undefined, // undefined:全部
  page = 1,
  size = 100,
  conditions,
  // 用于关联字段筛选功能
  refSheetId = "",
  refControlId = "",
  refSheetData = null,
  // 按文本模糊搜索
  searchText,
  searchCids = undefined, // undefined:全部
  sorts = [],
  // 树状结构搜索
  rootId, // 树状展示时，根节点数据id
  treeKey // 为树状展示，值是对应的关联字段。用viewId的时候可以不填
}) {
  if (dataIds) {
    dataIds = dataIds.filter(id => id)
    if (!dataIds.length) {
      // 此情况下必然无结果,无需请求
      return Promise.resolve({ content: [], totalElements: 0 })
    }
  }
  return request
    .post(`/public/getSheetData`, {
      sheetId,
      viewId,
      dataIds,
      page,
      size,
      filtersList: conditions,
      refSheetId,
      refCid: refControlId,
      refSheetData,
      searchText,
      searchCids,
      sorts,
      rootId,
      treeKey
    })
    .commonDeal()
}

export function getRawSheetDef(sheetId) {
  return request.get(`/public/getRawSheetDef`, { params: { sheetId } }).commonDeal()
}

export function getAvailableViews(sheetId) {
  return request.get(`/public/getAvailableViews`, { params: { sheetId } }).commonDeal()
}

export function getViewSummary(sheetId) {
  return request.get(`/public/getViewSummary`, { params: { sheetId } }).commonDeal()
}

export function getAllDefaultControls() {
  return request.get("/public/getAllDefaultControls").commonDeal()
}

export function getAllPublicAppTemplateList() {
  return request.get("/public/getAllPublicAppTemplateList").commonDeal()
}

export function getAppTemplateDetail(id) {
  return request.get("/public/getAppTemplateDetail", { params: { id } }).commonDeal()
}
